import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SanitizerPipe } from 'src/app/shared/pipes';

@Component({
    standalone: true,
    selector: 'app-fee',
    templateUrl: './fee.component.html',
    styleUrl: './fee.component.scss',
    imports: [CommonModule, SanitizerPipe, MatIconModule, MatTooltipModule],
})
export class FeeComponent implements OnInit {
    public tooltipInformation = '';
    public tooltipInformationHTML = '';

    @Input() feeLabel: string;
    @Input() feeValue: number;
    @Input() feeInfoTooltip?: string;
    @Input() getFeeInfoTooltip?: (name: string) => string;
    @Input() getFeeInfoTooltipHTML?: (name: string) => string;
    @Input() labelBold = false;
    @Input() fontClassLabel = '';
    @Input() valueBold = false;
    @Input() fontClassValue = '';
    @Input() size: 'small' | 'medium' | 'large' = 'medium';

    ngOnInit(): void {
        this.tooltipInformation =
            (this.getFeeInfoTooltip && this.getFeeInfoTooltip(this.feeLabel)) || this.feeInfoTooltip || '';

        this.tooltipInformationHTML = (this.getFeeInfoTooltipHTML && this.getFeeInfoTooltipHTML(this.feeLabel)) || '';
    }
}
